import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { GlobalConfig, I18n } from 'galarm-config'
import { Provider } from 'react-redux'
import configureStore, {
  purgeStateIfReducerVersionChanged
} from './store/configureStore'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ReactNotifications } from 'react-notifications-component'
import * as Sentry from '@sentry/react'
import BuildMetadata from './buildMetadata.json'

import 'react-notifications-component/dist/theme.css'

const { majorVersion, minorVersion, patchVersion } = BuildMetadata
const release = `${majorVersion}.${minorVersion}.${patchVersion}`

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release,
  environment: process.env.NODE_ENV
})

const { store, persistor } = configureStore()
GlobalConfig.store = store
GlobalConfig.persistor = persistor
purgeStateIfReducerVersionChanged(persistor)

GlobalConfig.release = release

const rootContainer = document.getElementById('root')
const root = createRoot(rootContainer)
root.render(
  <Sentry.ErrorBoundary fallback={<p>{I18n.t('somethingWentWrong')}</p>}>
    <BrowserRouter>
      <Provider store={store}>
        <ReactNotifications />
        <App />
      </Provider>
    </BrowserRouter>
  </Sentry.ErrorBoundary>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
